import { render, staticRenderFns } from "./FeedSection.vue?vue&type=template&id=697f15ec&scoped=true"
import script from "./FeedSection.vue?vue&type=script&lang=js"
export * from "./FeedSection.vue?vue&type=script&lang=js"
import style0 from "./FeedSection.vue?vue&type=style&index=0&id=697f15ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697f15ec",
  null
  
)

export default component.exports